 import PropertyIMG1 from "../../images/search-result/1.jpg";
import PropertyIMG2 from "../../images/search-result/2.jpg";
import PropertyIMG3 from "../../images/search-result/3.jpg";
import PropertyIMG4 from "../../images/search-result/4.jpg";
import PropertyIMG5 from "../../images/search-result/5.jpg";
import PropertyIMG6 from "../../images/search-result/6.jpg";
import PropertyIMG7 from "../../images/search-result/7.jpg";
import PropertyIMG8 from "../../images/search-result/8.jpg";
import PropertyIMG9 from "../../images/search-result/9.jpg";
import PropertyIMG10 from "../../images/search-result/10.jpg";
import PropertyIMG11 from "../../images/search-result/11.jpg";
import PropertyIMG12 from "../../images/search-result/12.jpg";

export const PropertyCardList = [
  {
    ImgLarge: PropertyIMG1,
    BedCount: "4",
    BathCount: "5",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "3,299,950 AED",
    PropertyHeading: "Vacant / Skyline Views / Motivated Seller",
    PropertyLocation: "Jumeirah Islands Townhouses",
    vidoeId: "IdejM6wCkxA",
  },
  {
    ImgLarge: PropertyIMG2,
    BedCount: "3",
    BathCount: "2",
    areaNumber: "2938 ft",
    areaSup: "2",
    PropertyPrice: "AED 1,050,000",
    PropertyHeading: "Vacant / Full Sea View / Furnished",
    PropertyLocation: "Dubai Marina",
    vidoeId: "J6UP_0SCWk0",
  },
  {
    ImgLarge: PropertyIMG3,
    BedCount: "5",
    BathCount: "5",
    areaNumber: "2129 ft",
    areaSup: "2",
    PropertyPrice: "3,300,000 AED",
    PropertyHeading: "Vacant Now / 5BR + Maids / Park Facing",
    PropertyLocation: "Jumeirah Village Triangle",
    vidoeId: "zZLxRcgimRI",
  },
  {
    ImgLarge: PropertyIMG4,
    BedCount: "2",
    BathCount: "1",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "3,495,000 AED",
    PropertyHeading: "Reduced / Adriatic / Vacant 3 Bed / Call Today",
    PropertyLocation: "Arabian Ranches",
    vidoeId: "rBYpB-PnYfg",
  },
  {
    ImgLarge: PropertyIMG5,
    BedCount: "3",
    BathCount: "2",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "3,120,000 AED",
    PropertyHeading: "Amazing Aseel / Type 2 / Single Row / Negotiable",
    PropertyLocation: "Deira",
    vidoeId: "2bLBm2ieSbU",
  },
  {
    ImgLarge: PropertyIMG6,
    BedCount: "3",
    BathCount: "2",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "2,675,000 AED",
    PropertyHeading: "Type A / Brand New / Emaar Warranty / Ready",
    PropertyLocation: "Greens",
    vidoeId: "2bLBm2ieSbU",
  },
  {
    ImgLarge: PropertyIMG7,
    BedCount: "4",
    BathCount: "3",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "2,500,000 AED",
    PropertyHeading: "Exclusive! / Rented 2Br + M / Large Plot",
    PropertyLocation: "Jebil Ali",
    vidoeId: "2bLBm2ieSbU",
  },
  {
    ImgLarge: PropertyIMG8,
    BedCount: "4",
    BathCount: "2",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "2,445,000 AED",
    PropertyHeading: "Best Deal / Sea View / 3 Bed / Type A / Vacant",
    PropertyLocation: "Mudon",
    vidoeId: "V8ksSGxo6no",
  },
  {
    ImgLarge: PropertyIMG9,
    BedCount: "4",
    BathCount: "1",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "2,190,000 AED",
    PropertyHeading: "Vacant / Skyline Views / Motivated Seller",
    PropertyLocation: "Meadows",
    vidoeId: "V8ksSGxo6no",
  },
  {
    ImgLarge: PropertyIMG10,
    BedCount: "4",
    BathCount: "3",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "2,500,000 AED",
    PropertyHeading: "Exclusive! / Rented 2Br + M / Large Plot",
    PropertyLocation: "Jebil Ali",
    vidoeId: "V8ksSGxo6no",
  },
  {
    ImgLarge: PropertyIMG11,
    BedCount: "4",
    BathCount: "2",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "2,445,000 AED",
    PropertyHeading: "Best Deal / Sea View / 3 Bed / Type A / Vacant",
    PropertyLocation: "Mudon",
    vidoeId: "V8ksSGxo6no",
  },
  {
    ImgLarge: PropertyIMG12,
    BedCount: "4",
    BathCount: "1",
    areaNumber: "3630 ft",
    areaSup: "2",
    PropertyPrice: "2,190,000 AED",
    PropertyHeading: "Vacant / Skyline Views / Motivated Seller",
    PropertyLocation: "Meadows",
    vidoeId: "V8ksSGxo6no",
  },
];
